export interface CartRequestContext {
  siteUid: string;
  language: string | null;
  authenticated: boolean;
  userId: string | null;
  soldTo: string | null;
  salesOrg: string | null;
  endCustomer: string | null;
}

export function cartRequestContextKey(context: CartRequestContext): string {
  return JSON.stringify([context.siteUid, context.userId, context.soldTo, context.salesOrg, context.endCustomer]);
}

export function cartRequestUrl(context: CartRequestContext, cartPath = ""): string {
  const user = context.authenticated ? "current" : "anonymous";
  const params = new URLSearchParams();
  if (context.language) {
    params.set("lang", context.language);
  }
  if (context.soldTo) {
    params.set("soldTo", context.soldTo);
  }
  if (context.salesOrg) {
    params.set("salesOrg", context.salesOrg);
  }
  if (context.endCustomer) {
    params.set("endCustomer", context.endCustomer);
  }
  const query = params.toString();
  return `/occ/v2/${context.siteUid}/users/${user}/carts${cartPath}${query ? `?${query}` : ""}`;
}
